import { render } from "./AudiosApp.vue?vue&type=template&id=f384b658"
import script from "./AudiosApp.vue?vue&type=script&lang=js"
export * from "./AudiosApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__